import { getFooterLinkEventData } from "~/lib/gtm/getGtmEventData"
import GTMEventLink from "~/components/ui/GTMEventLink"
import { footerLegalLinks } from "~/data/footer";

const FooterLegalLinks = () => {
    return (
        <ul className="flex gap-6 max-md:flex-col">
            {footerLegalLinks.map(({ label, href }) => (
                <li key={label}>
                    <GTMEventLink
                        href={href}
                        className="block text-sm lg:text-base text-white leading-normal"
                        gtmEventData={getFooterLinkEventData(label)}
                    >
                        {label}
                    </GTMEventLink>
                </li>
            ))}
        </ul>
    );
};

export default FooterLegalLinks;
